import { Component } from '@angular/core';

@Component({
  selector: 'app-listing-layout',
  standalone: true,
  imports: [],
  templateUrl: './listing-layout.component.html',
  styleUrl: './listing-layout.component.scss'
})
export class ListingLayoutComponent {

}
